import React, { useState, useEffect, useRef } from 'react';
import './SchoolFeatures.css';
import pic1 from "../assets/promiselogo.webp";
import pic2 from "../assets/futurelogo.webp";
import pic3 from '../assets/globlogo.webp';
import pic4 from "../assets/learnlogo.webp";

const SchoolFeaturesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div className="features-wrapper">
      <div 
        className="features-container"
        ref={containerRef}
      >
        
        {/* Top Left - Yellow Box */}
        <div className={`feature-box yellow-boxa top-left ${isVisible ? 'animate-left' : ''}`}>
          <div className="box-icona"><img src={pic1} alt="" id='prologo'/></div>
          <h2 className="box-titlea">A PROMISE TO YOUR CHILD</h2>
          <p className="box-text">
            Our school community provides a warm and friendly welcome for your child. Our Principal and our staff promise to support your child to become a global learner and aspiring leader. Throughout school years, your child becomes ours and we promise a happy, secure and enlightening experience.
          </p>
        </div>

        {/* Top Right - Brown Box */}
        <div className={`feature-box brown-boxb top-right ${isVisible ? 'animate-right' : ''}`}>
          <div className="box-iconb"><img src={pic3} alt="" id='glologo'/></div>
          <h2 className="box-titleb">GLOBAL CAMPUS</h2>
          <p className="box-text">
            The world is full of possibilities, from new discoveries to new friendships. We bring our worldwide family of schools together using our Global Campus, giving students a chance to work together and learn about different communities.
          </p>
          <p className="box-text">
            Our Global Campus helps students explore the world, learn new skills and set their sights higher, developing a truly international perspective through outstanding online, in-school and worldwide experiences. We inspire your child to is and ambitions and be hungry in their
          </p>
        </div>

        {/* Bottom Left - Brown Box (Spans more) */}
        <div className={`feature-box brown-boxc bottom-left ${isVisible ? 'animate-left' : ''}`}>
          <div className="box-iconc"><img src={pic4} alt="" id='lerlogo'/></div>
          <h2 className="box-titleb">HIGHEST QUALITY LEARNING</h2>
          <p className="box-text">
            At Bihani Children's Academy School, your child will be given the opportunity to excel in many different ways. Our approach is to build the confidence and drive that inspires each student to achieve their goals and surpass the expectations.
          </p>
          <p className="box-text">
            Our team of teaching staff provides the highest quality of learning where all students are given the opportunities to achieve their very best. With small class sizes, our teachers know each child and how to enable them to make exceptional achievements in all areas of the curriculum.
          </p>
        </div>

        {/* Bottom Right - Yellow Box */}
        <div className={`feature-box yellow-boxd bottom-right ${isVisible ? 'animate-right' : ''}`}>
          <div className="box-icond"><img src={pic2} alt="" id='futlogo'/></div>
          <h2 className="box-titlea">FUTURE ENSURED</h2>
          <p className="box-text">
            Our students have the privilege of securing placements in their desired fields at prestigious higher education institutions worldwide. We have established partnerships and networks with renowned colleges and universities, offering opportunities for credit recognition and facilitating placements for our students.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolFeaturesSection;